/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Plugin_Cap_LabelInputs */



/**
* | output |
* | --- |
* | "Extra credits: monthly spending limit (USD)" |
*
* @param {Agent_Plugin_Cap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_cap_label = /** @type {((inputs?: Agent_Plugin_Cap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Cap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Crédits supplémentaires : plafond mensuel (USD)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusätzliche Credits: monatliches Limit (USD)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crediti extra: limite mensile (USD)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительные кредиты: месячный лимит (USD)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Créditos adicionales: límite mensual (USD)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("额外积分：每月支出上限（美元）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加クレジット: 月額上限 (USD)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अतिरिक्त क्रेडिट: मासिक खर्च सीमा (USD)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Créditos adicionais: limite mensal (USD)")
	return /** @type {LocalizedString} */ ("Extra credits: monthly spending limit (USD)")
});